import { NAME } from 'domain/operations/drivers/itineraryStatus/view/constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCHED: `${NAME}/FETCHED`,

  MARK_AS_COLLECTED: `${NAME}/MARK_AS_COLLECTED`,
  MARKED_AS_COLLECTED: `${NAME}/MARKED_AS_COLLECTED`,

  MARK_AS_RECEIVED: `${NAME}/MARK_AS_RECEIVED`,
  MARKED_AS_RECEIVED: `${NAME}/MARKED_AS_RECEIVED`,

  CONFIRM_CASH_COLLECTED: `${NAME}/CONFIRM_CASH_COLLECTED`,
  CONFIRMED_CASH_COLLECTED: `${NAME}/CONFIRMED_CASH_COLLECTED`,

  ATTACH_TO_ITINERARY: `${NAME}/ATTACH_TO_ITINERARY`,
  SHIPMENT_ATTACHED: `${NAME}/SHIPMENT_ATTACHED`,

  DEATTACH_FROM_ITINERARY: `${NAME}/DEATTACH_FROM_ITINERARY`,
  SHIPMENT_DEATTACHED: `${NAME}/SHIPMENT_DEATTACHED`,

  REARRANGE_SHIPMENTS: `${NAME}/REARRANGE_SHIPMENTS`,
  REARRANGE_DONE: `${NAME}/REARRANGE_DONE`,
  UPDATE_RECIPIENT: `${NAME}/UPDATE_RECIPIENT`,
  UPDATED_RECIPIENT: `${NAME}/UPDATED_RECIPIENT`,
  TOGGLE_UPDATE_RECIPIENT_SCREEN: `${NAME}/TOGGLE_UPDATE_RECIPIENT_SCREEN`,
};
